import React from 'react';
import { Box, Dialog, Stack, Text } from 'braid-design-system';
import PageLoader from '../../common/PageLoader';
import ButtonGroup from '../../common/ButtonGroup/ButtonGroup';
import { useTranslations } from '@vocab/react';
import translations from './.vocab';

interface Props {
  isOpen: boolean;
  loading: boolean;
  error: any;
  onClose: () => void;
  onSuccess: () => void;
}

export const DeleteBrandModalContent = ({
  isOpen,
  onClose,
  loading,
  error,
  onSuccess,
}: Props) => {
  const { t } = useTranslations(translations);

  return (
    <Dialog
      id="deleteBrandModal"
      open={isOpen}
      title={t('Delete this brand')}
      onClose={onClose}
    >
      {loading && <PageLoader />}
      {error && (
        <Box marginTop="xxlarge">
          <Text tone="critical">{t('Can we try that again?')}</Text>
        </Box>
      )}
      {!loading && !error && (
        <Stack space="xlarge">
          <Text size="large">
            {t('You are about to permanently delete this brand from SEEK.')}
          </Text>
          <ButtonGroup
            successText={t('Delete')}
            cancelText={t('Cancel')}
            onSuccess={onSuccess}
            onCancel={onClose}
          />
        </Stack>
      )}
    </Dialog>
  );
};

export default DeleteBrandModalContent;
